require('./Partials/jquery-global');
var autocomplete = require('jquery-autocomplete')
var jqueryUi = require('jquery-ui')
var _ = require('lodash');
var moment = require('moment');
var pickadate = require('pickadate/lib/picker.date');
var countUp = require('countup.js/dist/countUp.umd');

require('popper.js');
require('bootstrap');
require('magnific-popup');
require('shariff');
require('slick-carousel');
require('clndr');
require('friendly-challenge/widget');

// Custom partial scripts
require('./Partials/AcmCalculator');
require('./Partials/Slider');
require('./Partials/Accordion');
require('./Partials/Lightbox');
require('./Partials/BootstrapHandlers');
require('./Partials/Utilities');
require('./Partials/BackToTop');
require('./Partials/NewsExtended');
require('./Partials/Femanager');
require('./Partials/Felogin');
require('./Partials/Calendar');
require('./Partials/Webcode');
require('./Partials/AcmCompanydirectory');
require('./Partials/AcmPictureVote');
require('./Partials/Expertenjury');
require('./Partials/MobileMenu');
require('./Partials/Search');
require('./Partials/Solr');
//require('./Partials/Cookiebot');
require('./Partials/DsCarousel');
require('./Partials/Dap');
